import { createTheme } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface Palette {
    misc: {
      navy: string
      navyDeep: string
      cyan: string
      primary: string
      primaryHover: string
      surface: string
    }
  }
  interface PaletteOptions {
    misc?: {
      navy: string
      navyDeep: string
      cyan: string
      primary: string
      primaryHover: string
      surface: string
    }
  }
}

export const MISC_NAVY = '#0a1f3c'
export const MISC_NAVY_DEEP = '#061525'
export const MISC_CYAN = '#22d3ee'
export const MISC_PRIMARY = '#2563eb'
export const MISC_PRIMARY_HOVER = '#1d4ed8'
export const MISC_SURFACE = '#f4f6f9'

export const onboardingTheme = createTheme({
  palette: {
    primary: {
      main: MISC_PRIMARY,
      dark: MISC_PRIMARY_HOVER,
    },
    background: {
      default: MISC_SURFACE,
      paper: '#ffffff',
    },
    misc: {
      navy: MISC_NAVY,
      navyDeep: MISC_NAVY_DEEP,
      cyan: MISC_CYAN,
      primary: MISC_PRIMARY,
      primaryHover: MISC_PRIMARY_HOVER,
      surface: MISC_SURFACE,
    },
  },
  typography: {
    fontFamily: '"Inter", ui-sans-serif, system-ui, sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': {
            backgroundColor: MISC_PRIMARY_HOVER,
          },
        },
        outlined: {
          textTransform: 'none',
          fontWeight: 500,
        },
        text: {
          textTransform: 'none',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: MISC_PRIMARY,
        },
      },
    },
  },
})
